import { styled } from "@mui/material/styles";

const StyledInvoice = styled("div")(
  ({ theme }) => `
  @media screen and (max-width: 600px) {
    margin: 0px 20px;
  }
  
  .main-container{
  width: 100%;
  background-color:${theme.palette.customColor.white};
  margin-top: 20px;
}
  .search-filter-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.search-box .MuiOutlinedInput-root {
  width: 343px;
  height: 48px;
background-color: ${theme.palette.customColor.white};
  outline: none !important;
    border-radius: 0;
font-family: Lexend;
font-weight: 400;
font-size: 14px;
line-height: 100%;
@media (max-width: 600px) {
    width: 63vw

}

}


  

 .MuiOutlinedInput-notchedOutline {
border: 0.8px solid ${theme.palette.customColor.secondaryThird} !important;
  }

.searchIcon{
    width: 20px;
    height: 20px;
}
.MuiInputAdornment-root{
margin-right: 12px;
}
.MuiOutlinedInput-input{
font-family: 'Lexend', sans-serif;
    font-weight: 400;
    font-size: 14px;
    line-height: 17.5px;
}
.filter-box {
  width: 100%;
  max-width: 200px;
  height: 40px;
  background-color: white;
  border-radius: 0px;
}

.filter-value{
  font-family: Lexend;
font-size: 15px !important;
text-transform: capitalize;
color: ${theme.palette.primary.main};}

.placeholder{
font-family: 'Lexend', sans-serif;
    font-weight: 400;
    font-size: 15px;
    line-height: 18.75px;
    color: #656565;
}

.select-data{
font-family: 'Lexend', sans-serif;
    font-weight: 400;
    font-size: 14px !important;
    line-height: 21px;
    color: #050505;
}

.mobile-filter-button{
width: 100%;
max-width: 100px;
height: 50px;
background-color: white;
border-radius:0px;
padding : 14px 12px 14px 12px;

@media (max-width: 600px) {
    width: 30vw;
    height: 45px;
    border: 0.8px solid ${theme.palette.customColor.secondaryThird} !important;
}
.filter{
font-family: 'Lexend', sans-serif;
    font-weight: 400;
    font-size: 12px;
    line-height: 15px;
    color: #050505;
    text-transform: capitalize;

}

.filter-icon{
width: 20px;
height: 20px;
}

 
`
);

export default StyledInvoice;